<!--Header-->
<app-landingpage-header-child [disableLogin]="true"></app-landingpage-header-child>
<!-- End Header-->

<!-- Content -->
<div id="wrapper">
  <mat-card>
    <mat-card-header>
      <mat-card-title>{{'kyc.sign_title' | translate}}</mat-card-title>
    </mat-card-header>
    <mat-card-content class="pt-2">
      <mat-accordion #accordion="matAccordion" [multi]="true">
        <mat-expansion-panel expanded="true">
          <div class="steps-title pt-4">
            <!--    title của step-->
            <nz-steps [nzCurrent]="current">
              <nz-step [nzTitle]="titleStep1">
                <ng-template #titleStep1>{{'enterprise_contract.image_signing.title_step_1' | translate}}</ng-template>
              </nz-step>
              <nz-step [nzTitle]="titleStep2">
                <ng-template #titleStep2>{{'enterprise_contract.image_signing.title_step_2' | translate}}</ng-template>
              </nz-step>
              <nz-step [nzTitle]="titleStep3">
                <ng-template #titleStep3>{{'enterprise_contract.image_signing.title_step_3' | translate}}</ng-template>
              </nz-step>
              <nz-step [nzTitle]="titleStep4">
                <ng-template #titleStep4>{{'enterprise_contract.image_signing.title_step_4' | translate}}</ng-template>
              </nz-step>
            </nz-steps>
            <!--end title của step-->

            <!--    nội dung, các phần này thay đổi-->
            <!--    tab chọn phương thức ký-->
            <div [hidden]="current !=0" class="max-width-content-step0">
              <mat-dialog-content class="select-certificate">
                <div class="pt-5 pb-3">
                  <div class="col-12 mb-3">
                    <span
                      style="margin-bottom: 1em; font-family: inherit; display: inline-block; color: rgba(0, 0, 0, 0.65);">
                      {{'digital_certificate_management.cbx_certificate_type.lbl_certificate_type' | translate}} </span>
                    <br />
                    <mat-radio-group #typeCertificateSelect id="typeCertificate" [(ngModel)]="typeSelectCertificate"
                      (change)="onChangeSelectCertificateType($event.value)" name="typeCertificate"
                      #typeCertificate="ngModel" required maxlength="100">
                      <mat-radio-button [value]="signMethod.SIGN_SIM_CA" class="pr-5">
                        {{'digital_certificate_management.cbx_certificate_type.cbx_sim_ca' | translate}}
                      </mat-radio-button>
                      <mat-radio-button [value]="signMethod.SIGN_USB_TOKEN" class="pr-5">
                        {{'digital_certificate_management.cbx_certificate_type.cbx_usb' | translate}}
                      </mat-radio-button>
                      <mat-radio-button [value]="signMethod.SIGN_CLOUD_CA" class="pr-5">
                        {{'digital_certificate_management.cbx_certificate_type.cbx_cloud_ca' | translate}}
                      </mat-radio-button>
                    </mat-radio-group>
                    <mat-error *ngIf="typeCertificate.invalid">
                      <span class="text-error">
                        {{'validation.lbl_validation_certificate_required' | translate}}
                      </span>
                    </mat-error>
                  </div>
                </div>
              </mat-dialog-content>

              <!-- *********_SimCA_********* -->
              <!-- số điện thoại -->
              <div class="row usb-custom" *ngIf="typeSelectCertificate == 2">
                <div class="col-lg-4 col-sm-6 mt-3">
                  <mat-form-field class="w-100">
                    <span matPrefix>+84 &nbsp;</span>
                    <input matInput (focusout)="simCaPhoneNumber=simCaPhoneNumber.trim()" type="text"
                      placeholder="{{'digital_certificate_management.lbl_phone' | translate}}"
                      [(ngModel)]="simCaPhoneNumber" name="phoneNumber" #phoneNumber="ngModel" [maxlength]="maxLengthPhone" required>
                    <button mat-button *ngIf="simCaPhoneNumber" matSuffix mat-icon-button aria-label="Clear"
                      (click)="simCaPhoneNumber=null">
                      <mat-icon>close</mat-icon>
                    </button>
                    <mat-error *ngIf="phoneNumber.invalid">
                      <span class="text-error" *ngIf="phoneNumber?.errors?.required">
                        {{'validation.phone_number_re' | translate}}
                      </span>
                      <span class="text-error" *ngIf="phoneNumber?.errors?.validInput">
                        {{'validation.phone_format' | translate}}
                      </span>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-lg-8 col-sm-6 d-flex justify-content-start align-items-center">
                  <button mat-raised-button type="button" class="get-cts" [disabled]="!simCaPhoneNumber"
                    (click)="getCertificateOfSimCA()" color="primary">
                    <mat-icon class="mr-0">list</mat-icon>
                    {{'button.get_list' | translate}}
                  </button>
                </div>
              </div>
              <!-- danh sách CTS-->
              <div class="col-12 mobile-p0" *ngIf="typeSelectCertificate == 2 && listOfDataSimCa.length > 0">
                <nz-table [nzData]="listOfDataSimCa" #dynamicTable nzShowPagination="false" nzBordered="true">
                  <thead>
                    <tr>
                      <th></th>
                      <th>{{'enterprise_contract.table_headers.No' | translate}}</th>
                      <th>{{'enterprise-certificate_management.table_headers.cer_name' | translate}}</th>
                      <th>{{'enterprise-certificate_management.table_headers.serial_number' | translate}}</th>
                      <th>{{'headertable.tax_code_no' | translate}}</th>
                      <th>{{'enterprise-certificate_management.table_headers.effective_date' | translate}}</th>
                      <th>{{'enterprise-certificate_management.table_headers.expiry_date' | translate}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-template ngFor let-data [ngForOf]="dynamicTable.data">
                      <tr>
                        <td nzShowCheckbox [(nzChecked)]="data.checked" (nzCheckedChange)="onSelectedCert($event,data)">
                        </td>
                        <td>{{data.STT}}</td>
                        <td>{{data.certificateName}}</td>
                        <td>{{data.serialNumber}}</td>
                        <td>{{data.taxCode}}</td>
                        <td>{{data.activeDate | dateformat}}</td>
                        <td>{{data.expireDate | dateformat}}</td>
                      </tr>
                    </ng-template>

                  </tbody>
                </nz-table>
              </div>
              <!--*************** end SimCa **************-->
              <!-- *******_USB-Token_******* -->
              <!-- cách tải lên-->
              <div class="row">
                <div class="col-lg-8 col-sm-12">
                  <div class="mb-2" style="top: 2rem;" *ngIf="typeSelectCertificate == 1">
                    <!-- tải lên từ Usb-Token -->
                    <ng-container *ngIf="typeSelectCertificate == 1" #uploadFromUsb>
                      <div>
                        <button class="mb-3" mat-stroked-button color="primary" (click)="onGetCertificate()"
                          type="button">
                          <mat-icon class="mr-0">usb</mat-icon>
                          {{'digital_certificate_management.upload_usb_token' | translate}}
                        </button>
                      </div>

                      <mat-error>
                        <span class="text-error" *ngIf="errorStatus != null">
                          <ng-container *ngIf="errorStatus != 'messages.not_initPlugin'; else errorInitPlugin">
                            {{ errorStatus | translate}}
                          </ng-container>
                          <ng-template #errorInitPlugin>
                            <ng-container>
                              {{ 'messages.not_initPlugin' | translate}}
                            </ng-container>
                            <br>
                            <ng-container>
                              {{ 'messages.check_input_usbtoken' | translate}}
                            </ng-container>
                            <br>
                            <ng-container>
                              {{ 'messages.check_input_software' | translate}}
                              <a target="_blank" href="{{getLinkDownload('WINDOWS')}}">
                                <span style="cursor: pointer;">{{ 'messages.win' |
                                  translate}} </span>
                              </a>
                              <a target="_blank" href="{{getLinkDownload('MACOS')}}">
                                <span style="cursor: pointer;">{{ 'messages.mac' |
                                  translate}} </span>
                              </a>
                              <a target="_blank" href="{{getLinkDownload('LINUX')}}">
                                <span style="cursor: pointer;">{{ 'messages.linux' |
                                  translate}} </span>
                              </a>
                            </ng-container>

                          </ng-template>
                        </span>
                      </mat-error>
                    </ng-container>
                  </div>
                </div>
              </div>

              <!--            CLOUD CA-->
              <form>
                <div class="row" *ngIf="typeSelectCertificate == 4">
                  <div class="col-lg-4 col-sm-6 mt-3">
                    <div>
                      <mat-form-field>
                        <mat-label>{{'digital_certificate_management.lbl_provider_cloudca' | translate}}</mat-label>
                        <mat-select #providerSelect (focusout)="(checkFocus = true)"
                          (focus)="commonService.openComboBox(checkFocus, providerSelect)" id="providerSelect"
                          [(ngModel)]="providerName" (selectionChange)="checkFocus = false;" #provider="ngModel"
                          required name="providerSelect">
                          <mat-option *ngFor="let item of lstCloudCaProvider" [value]="item.name"
                            (click)="this.commonService.closeDropdownList(this.providerSelect)">
                            {{item.name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>

                  <div class="col-lg-4 col-sm-6 mt-3" *ngIf="typeSelectCertificate == 4">
                    <mat-form-field class="w-100">
                      <input matInput type="text"
                        placeholder="{{'digital_certificate_management.lbl_account_cloudca' | translate}}"
                        (focusout)="cloudCaUsername = cloudCaUsername.trim()" [(ngModel)]="cloudCaUsername"
                        name="cloudCaUsername" #cloudCaUserId="ngModel"
                        [ngClass]="{ 'is-invalid': cloudCaUserId.invalid }" maxlength="200" required>
                      <button mat-button *ngIf="cloudCaUsername" type="button" matSuffix mat-icon-button
                        aria-label="Clear" (click)="cloudCaUsername=''">
                        <mat-icon>close</mat-icon>
                      </button>
                      <mat-error *ngIf="cloudCaUserId.invalid">
                        <span class="text-error" *ngIf="cloudCaUserId?.errors?.required">
                          {{'validation.account_cloudca_required' | translate}}
                        </span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-4 col-sm-6 d-flex justify-content-start align-items-center"
                    *ngIf="typeSelectCertificate == 4">
                    <button mat-raised-button type="button" [disabled]="!cloudCaUsername || !providerName "
                      (click)="getCertificateCloudCa()" color="primary">
                      <mat-icon class="mr-0">list</mat-icon>
                      {{'button.get_list' | translate}}
                    </button>
                  </div>
                </div>
              </form>

              <!--             danh sách CTS-->
              <div class="col-12" *ngIf="typeSelectCertificate == 4 && cloudCaDataSource.length > 0">
                <nz-table [nzData]="cloudCaDataSource" #dynamicTable2 nzShowPagination="false" nzBordered="true">
                  <thead>
                    <tr>
                      <th></th>
                      <th>{{'enterprise_contract.table_headers.No' | translate}}</th>
                      <th>{{'enterprise-certificate_management.table_headers.cer_name' | translate}}</th>
                      <th>{{'enterprise-certificate_management.table_headers.serial_number' | translate}}</th>
                      <th>{{'headertable.tax_code_no' | translate}}</th>
                      <th>{{'digital_certificate_management.cloud_ca_acc' | translate}}</th>
                      <th>{{'enterprise-certificate_management.table_headers.effective_date' | translate}}</th>
                      <th>{{'enterprise-certificate_management.table_headers.expiry_date' | translate}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-template ngFor let-data [ngForOf]="dynamicTable2.data">
                      <tr>
                        <td nzShowCheckbox [(nzChecked)]="data.checked"
                          (nzCheckedChange)="onSelectedCloudCaCert($event,data)">
                        </td>
                        <td>{{data.STT}}</td>
                        <td>{{data.certificateName}}</td>
                        <td>{{data.serialNumber}}</td>
                        <td>{{data.taxCode}}</td>
                        <td>{{data.cloudCaUserId}}</td>
                        <td>{{data.activeDate | dateformat}}</td>
                        <td>{{data.expireDate | dateformat}}</td>
                      </tr>
                    </ng-template>

                  </tbody>
                </nz-table>
              </div>
              <!--            ******** END CLOUD CA *********-->
              <!-- Tôi đã đọc, hiểu rõ, đồng ý và cam kết tuân thủ các Điều khoản -->

              <div class="row usb-custom" *ngIf="typeSelectCertificate === 1 && this.usbTokenCertificate.issuedTo">
                <div class="col-6">
                  <mat-form-field class="w-100">
                    <input matInput type="text" placeholder="{{'digital_certificate_management.public_by' | translate}}"
                      [value]="usbTokenCertificate.issuedBy" id="cert_Issuer" readonly>
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field class="w-100">
                    <input matInput type="text"
                      placeholder="{{'digital_certificate_management.cer_subject_name' | translate}}"
                      [value]="usbTokenCertificate.issuedTo" id="cert_CN" readonly>
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field class="w-100">
                    <input matInput type="text"
                      placeholder="{{'digital_certificate_management.serial_number' | translate}}"
                      [value]="usbTokenCertificate.serialNumber" id="cert_SNB" readonly>
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field class="w-100">
                    <input matInput type="text" placeholder="{{'digital_certificate_management.mst_cmnd' | translate}}"
                      [value]="usbTokenCertificate.taxCode" id="taxcode" readonly>
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field class="w-100">
                    <input matInput type="text"
                      placeholder="{{'digital_certificate_management.start_date' | translate}}"
                      [value]="usbTokenCertificate.activeDate | date: 'dd/MM/yyyy'" id="cert_ValidFrom" readonly>
                  </mat-form-field>
                </div>
                <div class="col-6">
                  <mat-form-field class="w-100">
                    <input matInput type="text" placeholder="{{'digital_certificate_management.end_date' | translate}}"
                      [value]="usbTokenCertificate.expireDate | date: 'dd/MM/yyyy'" id="cert_ValidTo" readonly>
                  </mat-form-field>
                </div>
                <div class="col-6 d-none">
                  <mat-form-field class="w-100">
                    <input matInput type="text" placeholder="Raw Data" [value]="usbTokenCertificate.certRawdata"
                      id="cert_rawData" readonly>
                  </mat-form-field>
                </div>
              </div>
              <!-- ********** end Usb Token ************-->

            </div>
            <!--    end tab chọn phương thức ký-->

            <div class="steps-content max-width-content-step1 mt-5" *ngIf="current==1">
              <nz-tabset [nzTabPosition]="'top'" [nzType]="'card'" (nzSelectChange)="nzSelectChange($event)">
                <nz-tab [nzTitle]="registeredImage"
                  *ngIf="(selectedCert.typeCertificate !== signMethod.SIGN_NO_CERT) && (typeSelectCertificate !== signMethod.SIGN_NO_CERT)">
                  <ng-template #registeredImage>
                    {{'enterprise_contract.image_signing.registered_tab.tab_system_default' | translate}}
                  </ng-template>
                  <div class="tab-content">
                    <div *ngIf="selectedCert.imageUrl">
                      <ng-container *ngIf="!onlyDigital">
                        <img [src]="sanitize(selectedCert.imageUrl)" />
                      </ng-container>
                      <ng-container *ngIf="onlyDigital">
                        <div class="default-system-signature">
                        </div>
                      </ng-container>
                      <span class="guiding-info">
                        ({{'enterprise_contract.image_signing.registered_tab.no_image.only_digital' | translate}}) <br>
                      </span>
                    </div>
                    <div *ngIf="!selectedCert.imageUrl">
                      <div *ngIf="typeSelectCertificate !== signMethod.SIGN_OTP" class="default-system-signature">
                        <ng-container *ngIf="!onlyDigital">
                          {{'enterprise_contract.image_signing.registered_tab.no_image.signed_by' | translate}}:
                          {{selectedCert.issuedTo || selectedCert.certificateName}}
                          <br />
                          {{'enterprise_contract.image_signing.registered_tab.no_image.signed_date' | translate}}:
                          {{currentDate | dateformat}}
                        </ng-container>
                      </div>
                      <span class="guiding-info">
                        <ng-container *ngIf="onlyDigital">
                          ({{'enterprise_contract.image_signing.registered_tab.no_image.only_digital' | translate}})
                          <br>
                        </ng-container>
                        {{'enterprise_contract.image_signing.registered_tab.no_image.guiding' | translate}} <br>
                      </span>
                    </div>
                  </div>
                </nz-tab>
                <nz-tab [nzTitle]="uploadImage"
                  *ngIf="!onlyDigital || selectedCert.typeCertificate === signMethod.SIGN_NO_CERT">
                  <ng-template #uploadImage>{{'enterprise_contract.image_signing.new_tab.upload_image' | translate}}
                  </ng-template>
                  <div class="tab-content">
                    <div class="row">
                      <div class="clearfix nz-upload-clearfix">
                        <nz-upload [nzAccept]="'image/jpeg,image/jpg,image/png'" [nzPreview]="handlePreview"
                          class="avatar-uploader" [nzCustomRequest]="dummyRequest" nzName="avatar"
                          nzListType="picture-card" [nzShowUploadList]="false" [nzBeforeUpload]="beforeUpload"
                          (nzChange)="handleChange($event)">
                          <ng-container *ngIf="!avatarUrl">
                            <i class="upload-icon" nz-icon [nzType]="loading ? 'loading' : 'plus'"></i>
                            <div class="ant-upload-text">{{'form.select_upload' | translate}}</div>
                          </ng-container>
                          <img *ngIf="avatarUrl" [src]="sanitize(avatarUrl)" style="height: 100%" />
                        </nz-upload>
                      </div>
                    </div>

                    <span class="guiding-info">{{'title.upload_image_sign_guiding1' | translate}}
                      <br />{{'title.upload_image_sign_guiding2' | translate}}</span>
                  </div>
                </nz-tab>
                <nz-tab [nzTitle]="drawSignature" (nzSelect)="onSelectDrawSign()"
                  *ngIf="!onlyDigital || selectedCert.typeCertificate === signMethod.SIGN_NO_CERT">
                  <ng-template #drawSignature>{{'enterprise_contract.image_signing.new_tab.draw_signature' | translate}}
                  </ng-template>

                  <div class="steps-content">
                    <div class="tab-content">
                      <app-canvas [canvasWidth]="canvasWidth" [canvasHeight]="canvasHeight"></app-canvas>
                    </div>
                  </div>
                </nz-tab>
              </nz-tabset>
            </div>

            <div class="steps-content" *ngIf="current==2 || current == 3" class="max-width-content-step23">
              <div class="document">
                <div>
                  <ng-container *ngIf="pdfSrc != ''">
                    <ngx-extended-pdf-viewer [textLayer]="true" [src]="pdfSrc" (pageRendered)="pageRendered($event)"
                      (textLayerRendered)="textLayerRendered($event)" [(zoom)]="zoomLevel" [(page)]="pageCurrent"
                      [showToolbar]="true" useBrowserLocale="true" height="80vh" [handTool]="false"
                      [enablePrint]="false" [showDownloadButton]="false" [sidebarVisible]="true"
                      [showRotateButton]="false" [showOpenFileButton]="false" [showBookmarkButton]="false"
                      [showPropertiesButton]="true" [showUnverifiedSignatures]="true" [theme]="'dark'"
                      [language]="language" [zoomLevels]="[0.5,1,1.25, 1.5, 2, 3, 4]"
                      [showSidebarButton]="isShowSidebarButton">
                    </ngx-extended-pdf-viewer>
                  </ng-container>
                  <ng-template #notUpload>
                    <div *ngIf="pdfSrc" class="doc-wrapper view-document" [innerHTML]="pdfSrc | noSanitize"></div>
                  </ng-template>
                </div>
              </div>
            </div>
            <!--    end nội dung, các phần này thay đổi-->
          </div>
        </mat-expansion-panel>
        <div class="scontract-btn-deskbg-white boder-create-contract text-center mat-elevation-z0 py-2 w-100"
          id="navigation" #navigation>
          <button id="btn-cancel" mat-stroked-button color="primary" class="mr-3" type="button"
            (click)="onClickBtnCancel()">
            <mat-icon class="mr-0">cancel</mat-icon>
            {{'button.cancel' | translate}}
          </button>
          <button *ngIf="tempEnterprise" mat-stroked-button class="mr-3 mat-stroked-button mat-primary" type="button" (click)="onClickBtnViewUpdate()">
            <mat-icon class="mr-0">edit</mat-icon>
            {{'button.edit_information' | translate}}
          </button>
          <!--      nút quay lại-->
          <button (click)="pre()" *ngIf="current > 0" mat-stroked-button class="mr-3" color="primary">
            <mat-icon class="mr-0">arrow_back</mat-icon>
            {{'button.back' | translate}}
          </button>
          <!--      nút tiếp tục -->
          <button (click)="next()" *ngIf="current < 2" mat-raised-button class="mr-3" color="primary"
            [disabled]="isDisableNextButton">
            {{'button.next' | translate}}
            <mat-icon class="mr-0">arrow_forward</mat-icon>
          </button>
          <!--      đến trang ký -->
          <button (click)="gotoSignPage()" *ngIf="current === 2" mat-stroked-button class="mr-3" color="primary">
            <mat-icon class="mr-0">pin_drop</mat-icon>
            {{'enterprise_contract.buttons.goto_signing_page' | translate}}
          </button>
          <button mat-stroked-button color="primary" class="mr-3" (click)="onStamped()"
            *ngIf="current === 2 && isAllowSelectSignPosition">
            <mat-icon class="mr-0">replay</mat-icon>
            {{'enterprise_contract.buttons.re_select_position' | translate}}
          </button>
          <button mat-raised-button color="primary" class="mr-3" (click)="onClickSignButton()" *ngIf="current === 2">
            <mat-icon class="mr-0">gesture</mat-icon>
            {{'enterprise_contract.buttons.sign' | translate}}
          </button>
        </div>
      </mat-accordion>

    </mat-card-content>
  </mat-card>
</div>